import "focus-within-polyfill";

import "./global/jquery-migrate";
import "./common/select-option-plugin";
import PageManager from "./page-manager";
import quickSearch from "./global/quick-search";
import currencySelector from "./global/currency-selector";
import mobileMenuToggle from "./global/mobile-menu-toggle";
import menu from "./global/menu";
import foundation from "./global/foundation";
import quickView from "./global/quick-view";
import cartPreview from "./global/cart-preview";
import privacyCookieNotification from "./global/cookieNotification";
import initConsentManagerTestIds from "./global/consent-manager-test-ids";
import initCartDrawerTestIds from "./global/cart-drawer-test-ids";
import carousel from "./common/carousel";
import svgInjector from "./global/svg-injector";
import productOptionGraphql from "./set-product-option-with-graphql";
import customJS from "./custom";

export default class Global extends PageManager {
  onReady() {
    initConsentManagerTestIds();
    initCartDrawerTestIds();
    const {
      show_card_swatch,
      channelId,
      cartId,
      productId,
      categoryId,
      secureBaseUrl,
      maintenanceModeSettings,
      adminBarLanguage,
    } = this.context;
    cartPreview(secureBaseUrl, cartId);
    quickSearch();
    currencySelector(cartId);
    foundation($(document));
    quickView(this.context);
    carousel(this.context);
    menu();
    mobileMenuToggle();
    privacyCookieNotification();
    svgInjector();
    customJS(this.context);
    if (show_card_swatch) {
      productOptionGraphql(this.context);
    }
  }
}
